import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import axios from 'axios';
import { Lightning, PaperPlaneRight, SpinnerGap, CheckCircle } from '@phosphor-icons/react';

const API = `${window.location.origin}/api`;

function QuickCapture({ onCaptured }) {
  const [input, setInput] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!input.trim() || submitting) return;

    setSubmitting(true);
    try {
      const res = await axios.post(`${API}/inbox/capture`, { raw_text: input.trim() }, { withCredentials: true });
      setInput('');
      setSuccess(true);
      setTimeout(() => setSuccess(false), 2000);
      if (onCaptured) onCaptured(res.data);
    } catch (err) {
      console.error('Quick capture failed:', err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="relative" data-testid="quick-capture-form">
      <div className="flex items-center gap-2 bg-white border border-slate-200 rounded-lg px-4 py-2.5 focus-within:border-navy focus-within:ring-2 focus-within:ring-blue-100 transition-all duration-200">
        <Lightning size={18} weight="duotone" className="text-navy flex-shrink-0" />
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Quick capture... e.g. 'Call Emeka Friday 3pm re Dangote contract'"
          disabled={submitting}
          className="flex-1 bg-transparent text-sm text-slate-900 placeholder:text-slate-400 focus:outline-none disabled:opacity-50"
          data-testid="quick-capture-input"
        />
        <AnimatePresence mode="wait">
          {success ? (
            <motion.div key="success" initial={{ scale: 0.8, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} exit={{ scale: 0.8, opacity: 0 }}>
              <CheckCircle size={20} weight="fill" className="text-emerald-600" />
            </motion.div>
          ) : (
            <motion.button
              key="submit"
              type="submit"
              disabled={submitting || !input.trim()}
              className="bg-navy text-white hover:bg-navy-hover disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200 rounded-md px-2.5 py-1.5 flex items-center gap-1.5 text-xs font-medium"
              data-testid="quick-capture-submit"
            >
              {submitting ? (
                <SpinnerGap size={14} className="animate-spin" />
              ) : (
                <PaperPlaneRight size={14} weight="fill" />
              )}
              <span className="hidden sm:inline">{submitting ? 'Parsing...' : 'Capture'}</span>
            </motion.button>
          )}
        </AnimatePresence>
      </div>
    </form>
  );
}

export default QuickCapture;
